import { capitalizeFirstLetter } from "../../../utils/capitalizeFirstLetter";
import style from "./RadioInput.module.scss";

function RadioInput({ list = [], activeItem, handleChange, locale, name, dictionary, currency, testId = null, custom = true, isAnnuallyOn }) {
	const isRu = locale === "ru";

	const oneCreditPrice = (activeItem, itsPayAsGo) => {
		if (activeItem === undefined) return;
		const { prices, credits } = activeItem;
		const factor = isRu ? 100 : 1000;
		const currencyPrices = prices[currency.text];
		const price = currencyPrices / credits;
		return parseInt(price * factor) / factor;
	};

	return (
		<div className={`${style.container} ${custom ? style.marginCustom : style.margin}`}>
			{list.map((item) => {
				const { id, credits, period } = item;
				return (
					<label id={testId} className={`${style.label} ${id === activeItem?.id ? style.active : ""}`} key={id} htmlFor={id}>
						<input className={style.input} type="radio" name={name} id={id} value={id} onChange={() => handleChange(item)} checked={activeItem?.id === id} />
						<div className={style.credits}>
							<span className={style.number}>{credits} </span> {dictionary["credits"] || "credits"}
							{name === "Pro" && period !== "yearly" && custom && <span className={style.text}>{dictionary["month_pricing"] || dictionary["month"]}</span>}
						</div>

						<span className={style.payOneCredit}>
							{" "}
							{isRu ? (
								<>
									{oneCreditPrice(item, name === "payAsGo")}
									{currency.symbol}
								</>
							) : (
								<>
									{currency.symbol}
									{oneCreditPrice(item, name === "payAsGo")}
								</>
							)}
							/{dictionary["credit"].toLowerCase() || "credit"}
						</span>
					</label>
				);
			})}
			{custom && (
				<label className={`${style.label} ${"contactUs" + name === activeItem?.id ? style.active : ""}`} htmlFor={"contactUs" + name}>
					<input
						className={style.input}
						type="radio"
						name={name}
						id={"contactUs" + name}
						value={"contactUs" + name}
						onChange={() => handleChange({ ...activeItem, id: "contactUs" + name })}
						checked={"contactUs" + name === activeItem?.id}
					/>
					<div className={`${style.credits} ${style.custom}`}>{dictionary["custom"].split(" - ")[0]}</div>
					<span className={`${style.text} ${style.custom}`}>{capitalizeFirstLetter(dictionary["custom"].split(" - ")[1])}</span>
				</label>
			)}
		</div>
	);
}

export default RadioInput;
